module.exports = __webpack_public_path__ + "img/icn_prize.3acc35b8.svg";